<!-- 服务类卡片样式 -->
<template>
	<div class="cardList" :class="{'haveBorder':border}">
		<!-- 上半部分名称 -->
		<div class="topName">
			<div class="leftName" :title="topName">{{topName.length > 9 ? topName.substr(0,9)+'..' : topName}}</div>
			<div style="width:80px;text-align: center;">
				<img :src="logoUrl" width="50" v-if="logoUrl">
				<img src="../../assets/img/rightIcon.png" width="50" v-else>
			</div>
		</div>
		<!-- 价格及查看详情 -->
		<div class="bottomPrice">
			<!-- 价格 -->
			<div class="price">
				￥{{price}}
			</div>
			<!-- 查看详情 -->
			<div style="font-size: 14px;">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			topName:{
				type:String,
				default:''
			},
			price: {
				type: Number,
				default:0
			},
			border:{
				type:Boolean,
				default:false
			},
			logoUrl:{
				type:String,
				default:''
			},
		},
		methods: {
			
		},
	}
</script>

<style scoped>
	.cardList{
		width:280px;
		height:140px;
		background-color: #fff;
		margin-bottom: 20px;
	}
	.cardList:hover{
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		-webkit-transition: all .28s ease-in .1s;
		transition: all .28s ease-in .1s;
	}
	.haveBorder{
		border: 1px solid #eee;
	}
	.cardList .topName{
		height:90px;
		border-bottom: 1px dashed #eee;
		line-height: 90px;
		display: flex;
	}
	.cardList .topName .leftName{
		font-size:18px;
		padding-left:15px;
		font-weight: bold;
		width:200px;
	}
	.cardList .bottomPrice{
		height: 50px;
		line-height:50px;
		display: flex;
		justify-content: space-between;
	}
	.cardList .bottomPrice .price{
		color: #ff7800;
		font-size: 18px;
		padding-left: 10px;
	}
	.cardList .bottomPrice .contentBtn{
		width: 60px;
		margin-right: 10px;
		color: #999;
		cursor: pointer;
	}
	.cardList .bottomPrice .contentBtn:hover{
		color: #C32A1A;
	}
</style>
